import { TextProps } from './styleModels';

export class AllergensButtonProps {
  constructor(item = {}) {
    this.text = item.text || '';
    this.image = item.image;
    this.textProps = new TextProps(item.textProps);
  }
}
